module.exports = __webpack_public_path__ + "img/logo.64b09783.jpg";